import {
  Component,
  EventEmitter,
  input,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { LoadingService } from '../../../services/shared/loading.service';
import { Subscription } from 'rxjs';
type ButtonType =
  | 'update'
  | 'reject'
  | 'reject-sec'
  | 'approve'
  | 'submit'
  | 'cancel'
  | '';
@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
})
export class ButtonComponent implements OnInit, OnDestroy {
  @Input() buttonText: string = 'Login';
  @Input() iconName: string = '';
  @Input() iconFrontOrBack: string = '';
  @Input() borderColor: string = '';
  @Input() page: string = '';
  @Output() buttonClick = new EventEmitter<{ page: string; form?: any }>();
  @Input() buttonColor: string = '#EF8936';
  @Input() form: any;
  @Input() btnClassName = '';
  @Input() disable = false;
  @Input() type = 'button';
  @Input() textColor: string = '';
  @Input() borderRadius: string = '';
  @Input() loading: boolean = false;

  @Input() btnStyleType: ButtonType = '';

  private subscribtion!: Subscription;

  constructor(private loadingService: LoadingService) {}
  ngOnInit(): void {
    this.subscribtion = this.loadingService.loading$.subscribe(
      (value) => (this.loading = value)
    );
  }
  onClick() {
    this.buttonClick.emit({ page: this.page, form: this.form }); // Emit the page name when clicked
  }
  ngOnDestroy(): void {
    this.subscribtion.unsubscribe();
  }
}
